import type { ReactNode } from 'react';
import { DrawerSection } from '../Drawer';
import { PoStatusBadge } from './PoStatusBadge';
import type { PoStatusKind } from './poStatus';

interface PurchaseOrderZoneProps {
    title: string;
    /** Omitted for the Dispatch zone: it has no status vocabulary of its own. */
    badge?: { kind: PoStatusKind; status: string };
    children: ReactNode;
}

// Same shape as DETAILS and ACTIVITY: an uppercase label with the status badge
// inline on it, rows beneath, no card. Actions live in the panel's Actions section.
export function PurchaseOrderZone({ title, badge, children }: PurchaseOrderZoneProps) {
    return (
        <DrawerSection
            title={title}
            action={badge ? <PoStatusBadge kind={badge.kind} value={badge.status} /> : undefined}
        >
            {children}
        </DrawerSection>
    );
}
